const state = {
    currentStepsIndex:1,
    currentSelectedGameItem:{}, //用户当前选择的游戏
    currentInputGameModelList:{}, //获取用户需要输入的游戏数据模型
    currentSelectObjectProperty:{}, //用户需要输入提交的游戏数据模型
    currentSelectGameProductType:1, //当前选择的游戏商品类型：1:游戏账号 2:游戏金币
 }
 const mutations = {  
    // 发布商品时的当前步骤索引
    setCurrentStepsIndex(state,payload){
        window.scrollTo(0, 0);
        //console.log('发布产品，当前步骤是：',payload)
        state.currentStepsIndex = payload;
    },
    //设置当前已经选择的游戏
    setCurrentSelectedGameItem(state,payload){
      console.log('当前已经选择的游戏：',payload)
      state.currentSelectedGameItem = payload;
    },
    //设置当前输入的游戏模型列表
    setCurrentInputGameModelList(state,payload){
      //console.log('当前游戏输入模型列表是：',payload)
      state.currentInputGameModelList = payload;
    },
    //设置当前选择的对象属性
    setCurrentSelectObjectProperty(state,payload){
      console.log('当前选择的游戏输入模型是：',payload)
      state.currentSelectObjectProperty[payload.itemTitle] = payload.itemValue;
      console.log(state.currentSelectObjectProperty);
    },
    //当前选择的游戏商品类型
    setCurrentSelectGameProductType(state,payload){
      //console.log('当前选择的游戏商品类型是：'+payload);
      state.currentSelectGameProductType = payload;
    }

 }
 
 const actions = {
    
 }
 
 const getters = {
 
 }
 
 export default {
    namespaced:true,
    state,
    mutations,
    actions,
    getters
 }